import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'office-auth-home-refund',
    templateUrl: './home-refund.component.html'
})
export class HomeRefundComponent implements OnInit {
    constructor(
        private route: ActivatedRoute,
        private router: Router,
    ) { }
    
    ngOnInit() { }

    consultar(){
        this.router.navigate(['/office/refunds/consult']);
    }

    solicitar(){
        this.router.navigate(['/office/refunds/request']);
    }

    irHomeFormatos() {
        this.router.navigate(['/office/news/home']);
    }
}


// WEBPACK FOOTER //
// /app/src/app/office/refunds/home-refund/home-refund.component.ts